var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{style:({'height': _vm.iframeHeight}),attrs:{"allow":"camera; microphone; fullscreen; speaker; display-capture","width":"100%","src":this.meta.attendee_url+'?_nickname='+_vm.consumer.name,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }